import { useState } from 'react';

/**
 * 雙欄穿梭框：左側為已啟用（可上下排序），右側為未啟用。
 */
export default function DualListTransfer({
  enabledKeys = [],
  allItems = [],
  onChange,
  leftTitle = '已啟用',
  rightTitle = '未啟用',
  disabled = false,
}) {
  const [selectedKey, setSelectedKey] = useState('');

  const itemMap = new Map(allItems.map((item) => [item.key, item]));
  const enabledSet = new Set(enabledKeys);
  const enabledItems = enabledKeys
    .map((key) => itemMap.get(key))
    .filter(Boolean);
  const disabledItems = allItems.filter((item) => !enabledSet.has(item.key));

  function emit(nextKeys) {
    onChange?.(nextKeys);
    if (selectedKey && !nextKeys.includes(selectedKey)) {
      setSelectedKey('');
    }
  }

  function moveToEnabled() {
    if (!selectedKey || enabledSet.has(selectedKey)) {
      return;
    }
    emit([...enabledKeys, selectedKey]);
  }

  function moveToDisabled() {
    if (!selectedKey || !enabledSet.has(selectedKey)) {
      return;
    }
    emit(enabledKeys.filter((key) => key !== selectedKey));
  }

  function moveUp() {
    const index = enabledKeys.indexOf(selectedKey);
    if (index <= 0) {
      return;
    }
    const next = [...enabledKeys];
    [next[index - 1], next[index]] = [next[index], next[index - 1]];
    emit(next);
  }

  function moveDown() {
    const index = enabledKeys.indexOf(selectedKey);
    if (index < 0 || index >= enabledKeys.length - 1) {
      return;
    }
    const next = [...enabledKeys];
    [next[index + 1], next[index]] = [next[index], next[index + 1]];
    emit(next);
  }

  function renderList(items, side) {
    return (
      <ul className="dual-list-transfer__list">
        {items.length === 0 ? (
          <li className="dual-list-transfer__empty">無資料</li>
        ) : (
          items.map((item) => {
            const isActive = item.key === selectedKey;
            return (
              <li
                key={item.key}
                className={`dual-list-transfer__item ${isActive ? 'is-active' : ''}`}
              >
                <button
                  type="button"
                  className="dual-list-transfer__item-btn"
                  disabled={disabled}
                  onClick={() => setSelectedKey(item.key)}
                >
                  {item.label}
                </button>
                {side === 'left' && isActive ? (
                  <span className="dual-list-transfer__sort">
                    <button
                      type="button"
                      className="dual-list-transfer__sort-btn"
                      disabled={disabled || enabledKeys.indexOf(item.key) <= 0}
                      onClick={() => {
                        setSelectedKey(item.key);
                        moveUp();
                      }}
                      aria-label="上移"
                    >
                      ↑
                    </button>
                    <button
                      type="button"
                      className="dual-list-transfer__sort-btn"
                      disabled={disabled || enabledKeys.indexOf(item.key) >= enabledKeys.length - 1}
                      onClick={() => {
                        setSelectedKey(item.key);
                        moveDown();
                      }}
                      aria-label="下移"
                    >
                      ↓
                    </button>
                  </span>
                ) : null}
              </li>
            );
          })
        )}
      </ul>
    );
  }

  return (
    <div className="dual-list-transfer">
      <div className="dual-list-transfer__panel">
        <div className="dual-list-transfer__panel-title">{leftTitle}</div>
        {renderList(enabledItems, 'left')}
      </div>
      <div className="dual-list-transfer__actions">
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={disabled || !selectedKey || enabledSet.has(selectedKey)}
          onClick={moveToEnabled}
          aria-label="加入左側"
        >
          ‹
        </button>
        <button
          type="button"
          className="btn btn-secondary btn-sm"
          disabled={disabled || !selectedKey || !enabledSet.has(selectedKey)}
          onClick={moveToDisabled}
          aria-label="移到右側"
        >
          ›
        </button>
      </div>
      <div className="dual-list-transfer__panel">
        <div className="dual-list-transfer__panel-title">{rightTitle}</div>
        {renderList(disabledItems, 'right')}
      </div>
    </div>
  );
}
